import React from "react";
import PropTypes from "prop-types";
import { Frame } from "@bitesite/react-figstrap";
import { selectionButtonType } from "./utilities";
import { Button } from "../../../odc-ui";
import styled from "styled-components/macro";

const BooleanButton = styled(Button)`
  text-transform: none;
  width: 100%;
`;

const BooleanSelection = ({
  question,
  selectedValue,
  onOptionClick,
  theme,
}) => {
  const booleanOptions = [
    { label: "No", value: false },
    { label: "Yes", value: true },
  ];

  return (
    <Frame vertical gap={10}>
      <div>{question}</div>
      <div>
        <Frame vertical gap={10}>
          {booleanOptions.map((booleanOption) => (
            <div key={booleanOption.value}>
              <BooleanButton
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  onOptionClick(booleanOption.value);
                }}
                type={selectionButtonType(
                  theme,
                  selectedValue === booleanOption.value
                )}
              >
                {booleanOption.label}
              </BooleanButton>
            </div>
          ))}
        </Frame>
      </div>
    </Frame>
  );
};

BooleanSelection.propTypes = {
  question: PropTypes.string.isRequired,
  selectedValue: PropTypes.string.isRequired,
  onOptionClick: PropTypes.func.isRequired,
  theme: PropTypes.string,
};

export default BooleanSelection;
